import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';        
import 'firebase/compat/functions';  
import 'firebase/compat/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyAm0N5nhvtH9KiZOGwvWS48v5S4GLfZbIs",
  authDomain: "sdm-sales-report-production.firebaseapp.com",
  databaseURL: "https://sdm-sales-report-production.firebaseio.com",
  projectId: "sdm-sales-report-production",
  storageBucket: "sdm-sales-report-production.appspot.com",
  messagingSenderId: "964312987811",
  appId: "1:964312987811:web:bfdb56f65661e77cce6716",
  measurementId: "G-92DR5H19B2",
};

export const app = firebase.initializeApp(firebaseConfig);
export const functions = app.functions("asia-southeast2");
export const db = app.firestore();

app.auth().setPersistence(firebase.auth.Auth.Persistence.SESSION);  
